import { useEffect, useState } from "react";
import Nav from "@/components/dw/Nav";
import Hero from "@/components/dw/Hero";
import Audience from "@/components/dw/Audience";
import USP from "@/components/dw/USP";
import HowItWorks from "@/components/dw/HowItWorks";
import About from "@/components/dw/About";
import Team from "@/components/dw/Team";
import Plans from "@/components/dw/Plans";
import Testimonials from "@/components/dw/Testimonials";
import Blog from "@/components/dw/Blog";
import Contact from "@/components/dw/Contact";
import Footer from "@/components/dw/Footer";
import WhatsAppFab from "@/components/dw/WhatsAppFab";
import LeadModal from "@/components/dw/LeadModal";

export default function Landing() {
  const [leadOpen, setLeadOpen] = useState(false);
  const [source, setSource] = useState("popup");

  const openLead = (src = "hero") => {
    setSource(src);
    setLeadOpen(true);
  };

  useEffect(() => {
    const shown = sessionStorage.getItem("dw_lead_shown");
    if (shown) return;
    const timer = setTimeout(() => {
      setSource("popup");
      setLeadOpen(true);
      sessionStorage.setItem("dw_lead_shown", "1");
    }, 9000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div>
      <Nav />
      <main>
        <Hero onOpenLead={() => openLead("hero")} />
        <Audience />
        <USP />
        <HowItWorks />
        <About onOpenLead={() => openLead("about")} />
        <Team />
        <Plans onOpenLead={() => openLead("plans")} />
        <Testimonials />
        <Blog />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFab />
      <LeadModal open={leadOpen} onOpenChange={setLeadOpen} source={source} />
    </div>
  );
}
